import { h6, resetAnchor } from '@payflip/ui';
import { Link as RouterLink } from 'react-router';
import styled, { keyframes } from 'styled-components';

export const Wrapper = styled.nav<{ collapsed: boolean }>`
  background-color: ${({ theme }): string => theme.palette_white};
  box-sizing: border-box;
  border-right-color: ${({ theme }): string => theme.palette_gray_0};
  border-right-style: solid;
  border-right-width: 1px;
  flex-shrink: 0;
  width: ${({ collapsed }): string => (collapsed ? '100px' : '250px')};
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: ${({ collapsed }): string =>
    collapsed ? 'center' : 'flex-start'};
  box-sizing: border-box;
  padding: ${({ theme, collapsed }): string => `${theme.spacing_unit_x4}
    ${collapsed ? theme.spacing_unit_x2 : theme.spacing_unit_x4}
    ${theme.spacing_unit_x2}`};

  & > a > div {
    margin-right: ${({ theme, collapsed }): string =>
      collapsed ? '0' : theme.spacing_unit_x1};
  }
`;

export const Link = styled(RouterLink)<{ selected: boolean }>`
  ${resetAnchor}
  ${h6}

  color: ${({ theme, selected }): string =>
    selected === true ? theme.palette_blue_100 : theme.palette_gray_60};
  text-align: center;
  transition: color 250ms ease;
  text-align: left;
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }): string => theme.spacing_unit_x2};

  & > span {
    position: relative;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const IconWrapper = styled.div<{ selected: boolean }>`
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  width: 34px;
  height: 34px;
  margin-left: 0;
  margin-right: ${({ theme }): string => theme.spacing_unit_x1};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, selected }): string =>
    selected === true ? theme.palette_blue_5 : 'transparent'};
  transition:
    background-color 250ms ease,
    color 250ms ease;
  position: relative;

  & > svg {
    height: 1rem;
  }
`;

export const Logo = styled.div<{ collapsed: boolean }>`
  display: block;
  width: ${({ collapsed }): string => (collapsed ? '50px' : '150px')};
  margin: 0 auto;
  margin-bottom: ${({ theme }): string => theme.spacing_unit_x4};

  & > svg {
    width: 100%;
    height: 100%;
  }
`;

export const BottomArea = styled.div`
  margin-top: auto;
`;
export const CollapseButtonWrapper = styled.div<{ collapsed: boolean }>`
  width: 100%;
  display: block;

  & > button {
    justify-content: center;
    width: 100%;
  }

  & > button > span:first-of-type {
    margin-right: ${({ collapsed, theme }): string =>
      collapsed ? '0' : theme.spacing_unit_x1};
  }
`;

export const badge = keyframes`
  0% {
    top: 0%;
    left: 0%;
    height: 100%;
    width: 100%;
  }

  100% {
    top: -100%;
    left: -100%;
    height: 300%;
    width: 300%;
  }
`;

export const Badge = styled.div<{ collapsed?: boolean }>`
  position: absolute;
  top: ${({ collapsed }): string =>
    collapsed ? '-5px' : 'calc(calc(1.375rem / 2) - 5px)'};
  right: ${({ collapsed }): string => (collapsed ? '-5px' : '-1.5rem')};
  border-radius: 50%;
  width: 10px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: 0%;
    left: 0%;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    background-color: ${({ theme }): string => theme.palette_primary_0};
    animation: ${badge} 750ms linear 3;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    background-color: ${({ theme }): string => theme.palette_primary_100};
  }
`;
